import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { TabsConsumer } from './TabsContext';
import Loader from '../Loader';
var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var buildContent = function buildContent(activeIndex, tabIdArray) {
    return React.Children.map(children, function (child, index) {
      var key = "list-".concat(index);
      return activeIndex === index && /*#__PURE__*/React.createElement("div", {
        key: key,
        role: "tabpanel",
        id: tabIdArray[index],
        "aria-labelledby": "tab__".concat(tabIdArray[index]),
        className: className
      }, child);
    });
  };

  return /*#__PURE__*/React.createElement(TabsConsumer, null, function (_ref2) {
    var activeIndex = _ref2.activeIndex,
        tabIdArray = _ref2.tabIdArray;
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement(Loader, null)
    }, buildContent(activeIndex, tabIdArray));
  });
};

TabPanel.propTypes = propTypes;
TabPanel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TabPanel",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TabPanel;